/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExerciseIntervalDto } from './ExerciseIntervalDto';
import {
    ExerciseIntervalDtoFromJSON,
    ExerciseIntervalDtoFromJSONTyped,
    ExerciseIntervalDtoToJSON,
    ExerciseIntervalDtoToJSONTyped,
} from './ExerciseIntervalDto';

/**
 * 
 * @export
 * @interface ExerciseTimingDto
 */
export interface ExerciseTimingDto {
    /**
     * 
     * @type {number}
     * @memberof ExerciseTimingDto
     */
    initTimeSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof ExerciseTimingDto
     */
    switchPauseSeconds?: number;
    /**
     * 
     * @type {Array<ExerciseIntervalDto>}
     * @memberof ExerciseTimingDto
     */
    intervals: Array<ExerciseIntervalDto>;
}

/**
 * Check if a given object implements the ExerciseTimingDto interface.
 */
export function instanceOfExerciseTimingDto(value: object): value is ExerciseTimingDto {
    if (!('intervals' in value) || value['intervals'] === undefined) return false;
    return true;
}

export function ExerciseTimingDtoFromJSON(json: any): ExerciseTimingDto {
    return ExerciseTimingDtoFromJSONTyped(json, false);
}

export function ExerciseTimingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExerciseTimingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'initTimeSeconds': json['initTimeSeconds'] == null ? undefined : json['initTimeSeconds'],
        'switchPauseSeconds': json['switchPauseSeconds'] == null ? undefined : json['switchPauseSeconds'],
        'intervals': ((json['intervals'] as Array<any>).map(ExerciseIntervalDtoFromJSON)),
    };
}

export function ExerciseTimingDtoToJSON(json: any): ExerciseTimingDto {
    return ExerciseTimingDtoToJSONTyped(json, false);
}

export function ExerciseTimingDtoToJSONTyped(value?: ExerciseTimingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initTimeSeconds': value['initTimeSeconds'],
        'switchPauseSeconds': value['switchPauseSeconds'],
        'intervals': ((value['intervals'] as Array<any>).map(ExerciseIntervalDtoToJSON)),
    };
}

